var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBiozentrumSquare = function SvgBiozentrumSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19.53 19.24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".biozentrum_square_svg__cls-1{fill:#5a2d87}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "biozentrum_square_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "biozentrum_square_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "biozentrum_square_svg__Symbols"
  }, /*#__PURE__*/React.createElement("g", {
    id: "biozentrum_square_svg__Navi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "biozentrum_square_svg__Group-38"
  }, /*#__PURE__*/React.createElement("path", {
    id: "biozentrum_square_svg__Fill-1",
    className: "biozentrum_square_svg__cls-1",
    d: "M7.58 14.45h-2.4a.84.84 0 0 1-.84-.83v-8.3a.84.84 0 0 1 .84-.83h2.31a2.72 2.72 0 0 1 2.9 2.73 2.69 2.69 0 0 1-1 2.07 2.88 2.88 0 0 1 1.16 2.2v.12a2.91 2.91 0 0 1-3 2.85M7.5 6.09H6v2.44h1.5a1.19 1.19 0 0 0 1.15-1.3A1.09 1.09 0 0 0 7.5 6.09m1.36 5.4a1.29 1.29 0 0 0-1.27-1.36H6v2.73h1.59a1.23 1.23 0 0 0 1.27-1.25v-.12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "biozentrum_square_svg__Fill-4",
    className: "biozentrum_square_svg__cls-1",
    d: "M18.65 14.45h-4.24a.84.84 0 0 1-.92-.9 1.2 1.2 0 0 1 .16-.52l3.85-6.94h-2.93a.8.8 0 1 1 0-1.6h4.06a.82.82 0 0 1 .9.87 1.33 1.33 0 0 1-.13.54l-3.67 6.95h2.94a.8.8 0 1 1 0 1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "biozentrum_square_svg__Fill-11",
    className: "biozentrum_square_svg__cls-1",
    d: "M10.78.63a.64.64 0 0 1-.64.63H.64A.64.64 0 0 1 0 .63.64.64 0 0 1 .64 0h9.49a.64.64 0 0 1 .64.63"
  }), /*#__PURE__*/React.createElement("path", {
    id: "biozentrum_square_svg__Fill-12",
    className: "biozentrum_square_svg__cls-1",
    d: "M10.78 18.61a.64.64 0 0 1-.64.63H.64a.63.63 0 1 1 0-1.24h9.49a.64.64 0 0 1 .64.63"
  }))))))));
};
export default SvgBiozentrumSquare;